export const IDR = (n) => {
  const num = Number(n || 0);
  return "Rp " + num.toLocaleString("id-ID", { maximumFractionDigits: 0 });
};

// Satuan unit produksi: BAG (menggantikan kg)
export const BAG = (n) => {
  const num = Number(n || 0);
  return num.toLocaleString("id-ID", { maximumFractionDigits: 2 }) + " bag";
};

// Backward-compat alias — same rendering ("bag")
export const KG = BAG;

export const DATE = (iso) => {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleDateString("id-ID", { year: "numeric", month: "short", day: "2-digit" });
  } catch {
    return iso;
  }
};

export const dateISOJakarta = (date = new Date()) => {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: "Asia/Jakarta", year: "numeric", month: "2-digit", day: "2-digit",
  }).formatToParts(date);
  const map = Object.fromEntries(parts.filter(p => p.type !== "literal").map(p => [p.type, p.value]));
  return `${map.year}-${map.month}-${map.day}`;
};

export const todayISO = () => dateISOJakarta(new Date());

export const addDaysISO = (iso, days) => {
  const [y,m,d] = String(iso).split("-").map(Number);
  const dt = new Date(Date.UTC(y, (m||1)-1, (d||1) + days));
  return `${dt.getUTCFullYear()}-${String(dt.getUTCMonth()+1).padStart(2,"0")}-${String(dt.getUTCDate()).padStart(2,"0")}`;
};

export const startOfWeekISO = (iso) => {
  const [y,m,d] = String(iso).split("-").map(Number);
  const dow = (new Date(Date.UTC(y, (m||1)-1, d||1)).getUTCDay() + 6) % 7;
  return addDaysISO(iso, -dow);
};

export const ROLE_LABEL = {
  superadmin: "Super Admin",
  admin: "Admin",
  produksi: "Produksi",
  distribusi: "Distribusi",
  kasir: "Kasir",
  auditor: "Auditor",
  akunting: "Akunting",
  hrd: "HRD",
  usp: "Pengelola USP",
  checker: "Checker",
  driver: "Driver",
  armada: "Armada",
};

export const SHIFT_LABEL = {
  1: "Shift 1 (Pagi)",
  2: "Shift 2 (Siang)",
  3: "Shift 3 (Malam)",
};

export const JENIS_PELANGGAN = {
  agen_depo: "Agen / Depo",
  retail: "Retail",
};

export const KLASIFIKASI_ARMADA = {
  mobil: "Armada Mobil",
  motor: "Armada Motor (Motoris)",
  pabrik: "Pabrik (On-the-Spot)",
};
